import React, { useRef, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import { Link } from "react-router-dom";

import "swiper/css";
import "swiper/css/navigation";

import SkeletonCard from "../skeletoncard/SkeleotoncardComp";

export default function AllPackages() {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const getSkeletonCount = () => {
    if (window.innerWidth < 640) return 1;   
    if (window.innerWidth < 1024) return 3;  
    return 4;                                
  };

  const [skeletonCount, setSkeletonCount] = useState(getSkeletonCount());


  useEffect(() => {
    const handleResize = () => {
      setSkeletonCount(getSkeletonCount());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // const skeletonCount = 4;

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await fetch("https://demo.bonvoytourism.com/bonvoytourismbackend/api/packages");
        // const res = await fetch("https://demo.bonvoytourism.com/bonvoytourismbackend/api/packages");
        const json = await res.json();
        setData(json.packages || []);
      } catch (error) {
        console.error("Error fetching packages:", error);
      }
      setLoading(false);
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 mt-12 md:mt-22">
        {Array.from({ length: skeletonCount }).map((_, i) => (
          <SkeletonCard key={i} />
        ))}
      </div>
    );
  }

  return (
    <div className="relative mt-12 md:mt-22 group">
      <Swiper
        modules={[Navigation, Autoplay]}
        spaceBetween={15}
        slidesPerView={1}
        centeredSlides
        loop
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        breakpoints={{
          640: { slidesPerView: 3, spaceBetween: 15 },
          1024: { slidesPerView: 4, spaceBetween: 15 },
        }}
        navigation={{
          prevEl: prevRef.current,
          nextEl: nextRef.current,
        }}
        onBeforeInit={(swiper) => {
          swiper.params.navigation.prevEl = prevRef.current;
          swiper.params.navigation.nextEl = nextRef.current;
        }}
      >
        {data.map((pkg) => (
          <SwiperSlide key={pkg.id}>
            <Link
              to={`/tour/${pkg.id}`}
              className="max-w-[350px] mx-auto h-full flex flex-col"
            >
              <img
                src={pkg.img}
                alt={pkg.title}
                className="w-full h-auto md:h-[250px] object-cover"
              />

              <div className="py-5 px-3 md:px-5 flex flex-col justify-between h-full border border-[#ddd] min-h-[190px]">
                <h3 className="text-[#4E4E4E] text-[18px] font-semibold">
                  {pkg.title}
                </h3>

                <div className="flex justify-between gap-4 items-center mt-3">
                  <div>
                    <p className="text-[#8C8C8C] text-[13px]">
                      Duration {pkg.duration}
                    </p>
                    <p className="text-[11px] text-[#ff9219]">
                      {pkg.rating}
                    </p>
                    <p className="text-[11px] text-[#6666]">
                      {pkg.reviews}
                    </p>
                  </div>

                  <div className="text-right">
                    <p className="text-[13px] text-[#4E4E4E]">From</p>
                    <h3 className="text-[#ff9219] text-[18px] font-semibold">
                      {pkg.price}
                    </h3>
                  </div>
                </div>
              </div>
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>

      <div
        ref={prevRef}
        className="swiper-button-prev hidden md:flex opacity-0 group-hover:opacity-100 transition-opacity absolute top-1/2 left-2 -translate-y-1/2 bg-black/60 p-2 rounded-full z-10"
      />

      <div
        ref={nextRef}
        className="swiper-button-next hidden md:flex opacity-0 group-hover:opacity-100 transition-opacity absolute top-1/2 right-2 -translate-y-1/2 bg-black/60 p-2 rounded-full z-10"
      />
    </div>
  );
}
